import * as React from "react";
import type { SVGProps } from "react";
const SvgMenuMeatballs = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#menu-meatballs_svg__a)">
      <path d="M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4M12 21a2 2 0 1 0 0-4 2 2 0 0 0 0 4M12 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4" />
    </g>
    <defs>
      <clipPath id="menu-meatballs_svg__a">
        <path fill="#fff" d="M10 3h4v18h-4z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgMenuMeatballs;
